import React from "react";
import ReactGA from "react-ga4";
import { Grid, Typography } from "@mui/material";
import { EventContext } from "../../contexts/EventContext";
import EventCard from "./components/EventCard";

import request from "../../utilities/requests";

const Home = () => {
  const { userData } = React.useContext(EventContext);
  const [events, setEvents] = React.useState([]);
  // React.useEffect(() => {
  //   const token = user.signInUserSession.accessToken.jwtToken;
  //   localStorage.setItem("token", token);
  //   console.log("Token set");
  // }, [user]);

  React.useEffect(() => {
    ReactGA.send({
      hitType: "pageview",
      page: "/",
      title: "Home",
    });
  }, []);

  React.useEffect(() => {
    const getEvents = async () => {
      const result = await request("events/dashboard");
      if (result.success) {
        setEvents(result.events);
      }
    };
    getEvents();
  }, []);

  return (
    <Grid container spacing={3} style={{ padding: 10 }}>
      {/* <Grid item xs={12} style={{ display: "flex", justifyContent: "center" }}>
        <img
          src={userData?.org?.style?.logo ? userData.org.style.logo : ""}
          alt="logo"
          style={{ height: 120, width: 120 }}
        />
      </Grid> */}
      <Grid
        item
        xs={12}
        style={{ display: "flex", justifyContent: "center", marginBottom: 50 }}
      >
        <Typography variant="h4">This Month's Events</Typography>
      </Grid>

      {events.map((event, i) => (
        <EventCard key={`${event._id}-${i}`} event={event} />
      ))}
    </Grid>
  );
};

export default Home;
